module.exports = {
  "landing.quoteInsurance": "Cotizar mi seguro"
}
